module.exports = __webpack_public_path__ + "media/images/email-6f1d560e.png";